import React from 'react';

export const MagnifierSvg = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.1435 12.1435L8.88086 8.88086"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.97171 10.086C8.24396 10.086 10.086 8.24396 10.086 5.97171C10.086 3.69945 8.24396 1.85742 5.97171 1.85742C3.69945 1.85742 1.85742 3.69945 1.85742 5.97171C1.85742 8.24396 3.69945 10.086 5.97171 10.086Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
